import { createTranslator, type useTranslations } from "next-intl"
import english from "@/translations/en/usage-rows.json"

const englishTranslator = createTranslator({locale: "en", messages: english, namespace: "UsageRows"})
export const { renderUsage, renderUnavailableUsage } = getUsageRows()

export function getUsageRows(t: ReturnType<typeof useTranslations<"UsageRows">> = englishTranslator, locale = "en") {
  return {renderUsage, renderUnavailableUsage}

  function renderUsage(
    label: string,
    current: number | undefined,
    limit: number | null | undefined,
  ) {
    const used = current ?? 0
    const limitStr = limit === null || limit === undefined ? t("unlimited") : new Intl.NumberFormat(locale).format(limit)
    const isAtLimit = limit !== null && limit !== undefined && used >= limit
    return (
      <div>
        <div className="text-xs text-muted-foreground">{label}</div>
        <div className={`text-sm font-mono ${isAtLimit ? 'text-destructive' : ''}`}>
          <span key={t("usage", {used, limit: limitStr})}>{t("usage", {used, limit: limitStr})}</span>
        </div>
      </div>
    )
  }

  function renderUnavailableUsage(label: string) {
    return (
      <div>
        <div className="text-xs text-muted-foreground">{label}</div>
        <div className="text-sm font-mono text-muted-foreground"><span key={t("unavailable")}>{t("unavailable")}</span></div>
      </div>
    )
  }
}
